import { Injectable, inject, signal } from '@angular/core';
import { Observable, catchError, of, shareReplay, tap } from 'rxjs';

import { ApiService } from './api.service';
import { ApiConstants } from '../constants/api.constants';
import { COUNTRIES, Country } from '../constants/countries.constants';
import { environment } from '../../../environments/environment';

/**
 * Serves the country list from the API, falling back to the local COUNTRIES
 * constant if the API is unavailable (or in dummy mode, where there's no backend).
 */
@Injectable({
  providedIn: 'root'
})
export class CountriesService {
  private readonly api = inject(ApiService);

  private readonly countries = signal<Country[]>(COUNTRIES);
  readonly list = this.countries.asReadonly();

  private request$?: Observable<Country[]>;

  loadCountries(): Observable<Country[]> {
    if (!this.request$) {
      this.request$ = this.fetchCountries().pipe(
        tap((countries) => this.countries.set(countries)),
        shareReplay(1)
      );
    }

    return this.request$;
  }

  private fetchCountries(): Observable<Country[]> {
    if (environment.dummy) {
      return of(COUNTRIES);
    }

    return this.api.get<Country[]>(ApiConstants.COUNTRIES).pipe(catchError(() => of(COUNTRIES)));
  }
}
